import { getIconProps, type IconProps } from '#types'

/**
 * Location icon — person silhouette on a curved base ("you are here").
 *
 * Used for location pickers, "current location" affordances, and address UI.
 */
export function LocationIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M12 4C13.6569 4 15 5.34315 15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <path
        d="M12 11V17"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M17.8008 14.0292C19.2507 14.7602 20 15.8241 20 17.0084C20 19.2129 16.4183 21 12 21C7.58172 21 4 19.2129 4 17.0084C4 15.8082 5.06158 14.7317 6.74178 14"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
